import React, { Component } from 'react';
import { Button } from 'reactstrap';
import Loader from 'components/loader/loader.js';

class ButtonWithLoader extends Component {
  constructor(props, context) {
    super(props);

    this.state = {
      disabled: props.disabled
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.disabled !== state.disabled) {
      return ({ disabled: props.disabled });
    } else return null;
  }

  render() {
    return (
      this.props.display
        ?
        <Loader
          loading={this.props.display}
          loaderStyle={this.props.buttonStyle}
        />
        :
        <div className={this.props.divStyle}>
          <Button
            color="primary btn-rounded"
            className={this.props.buttonStyle}
            disabled={this.state.disabled}
          >
            {this.props.buttonText}
          </Button>
        </div>
    );
  }
}
export default ButtonWithLoader;